export const READONLY_CONTEXT_ERROR = 'READONLY_CONTEXT';

export const READONLY_PREVIEW_MESSAGE = 'Not available in read-only preview';

export const READONLY_NOTICE_THROTTLE_MS = 3000;

// Each previewed org level is its own access-token claim; the API rejects more than this (ViewAsValidator).
export const VIEW_AS_MAX_ORG_LEVELS = 50;

export const VIEW_AS_TOO_MANY_ORG_LEVELS_MESSAGE = 'Pick up to {{max}} organization levels.';

export const VIEW_AS_MY_DATA_NOTE = '"My" data still refers to your own records, not to a user with this role.';

export const VIEW_AS_ENDED_MESSAGE = 'Your role preview has ended. You are back to your own role and organization levels.';
